export default __webpack_public_path__ + "static/media/FIU_OOP.dff02127.svg";